var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 28,
    viewBox: "0 0 55 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.716854 12.7149C0.00710302 13.4247 0.00710292 14.5754 0.716854 15.2851L12.2829 26.8512C12.9926 27.5609 14.1434 27.5609 14.8531 26.8512C15.5629 26.1414 15.5629 24.9907 14.8531 24.2809L4.5722 14L14.8531 3.7191C15.5629 3.00935 15.5629 1.85862 14.8531 1.14887C14.1434 0.439118 12.9926 0.439118 12.2829 1.14887L0.716854 12.7149ZM54.1016 12.1826L2.00197 12.1826L2.00197 15.8174L54.1016 15.8174L54.1016 12.1826Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.8bc8caf6bade56022943fa8fffa4b4ba.svg";
export { ForwardRef as ReactComponent };